var _effectorFileName = "/src/pages/api/teachers/constants.ts";
import { v4 as uuid } from 'uuid';
import type { Teacher } from './types';
export const TEACHERS_LIST: Array<Teacher> = [{
  id: uuid(),
  name: 'Нина',
  surname: 'Вартанова',
  patronymicName: 'Юрьевна',
  taxNumber: '860205995854',
  tel: '79539996697',
  img: '/images/teachers/nina.webp',
  facts: ['Диплом переводчика, сейчас магистратура в Италии по направлению Language and Mind: Linguistic and Cognitive Studies', 'Сдала TOEFL на 110 из 120 - знает, как подготовиться к экзамену на максимум без лишнего стресса', 'Специализируется на фонетике, фонологии и психолингвистике — учит не зубрить правила, а понимать, как устроен язык', 'Ставит чистое произношение, помогает заговорить без барьера и подтянуть грамматику'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'Полина',
  surname: 'Холодякова',
  patronymicName: 'Игоревна',
  taxNumber: '760604641798',
  tel: '79160718206',
  img: '/images/teachers/polina.webp',
  facts: ['Уровень языка С2', 'Сертификат CELTA Cambridge', 'Работала преподавателем во Вьетнаме', '4 года работала переводчиком'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'Юлия',
  surname: 'Журкина',
  patronymicName: 'Юрьевна',
  taxNumber: '366514629820',
  tel: '79204294344',
  img: '/images/teachers/julia.webp',
  facts: ['15000+ успешно проведенных уроков', 'Преподавала английский язык в крупных компаниях (Mail.Ru, Sibur, Estee Lauder, Clinique и т.д.)', 'С удовольствием работаю с узкими запросами от делового английского до дизайна интерьеров', 'Учу говорить и думать на английском'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'Лолита',
  surname: 'Уланова',
  patronymicName: 'Сергеевна',
  taxNumber: '166004484971',
  tel: '79518988142',
  img: '/images/teachers/lolita.webp',
  facts: ['Работала ассистентом на Гала ужине на Каннском кинофестивале', 'Преподаю английский более 5 лет, знаю французский на В2', 'Более 2 лет прожила за границей (год во Франции, в Европе, еще один год – в Азии)', 'Имею международный сертификат Аштанга йоги, обучалась в Индии'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'Ian',
  surname: 'Quigley',
  patronymicName: '',
  taxNumber: 'COMPANY',
  tel: 'COMPANY',
  img: '/images/teachers/ian.webp',
  facts: ['Носитель языка с опытом преподавания 33 года', 'Преподает Business English, HR management English и General English', 'Имеет опыт работы интервьюером в англоязычных компаниях', 'Преподавал в крупных Европейских и Российских вузах'],
  isVisibleOnPaymentPage: false
}, {
  id: uuid(),
  name: 'Анастасия',
  surname: 'Хасанова',
  patronymicName: 'Сергеевна',
  taxNumber: '744722919331',
  tel: '79634664467',
  img: '/images/teachers/nastya.webp',
  facts: ['Опыт преподавания 10 лет', 'Жила и работала в США', 'Работала синхронным переводчиком, в том числе со сцены', 'Сопровождала иностранные делегации'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'Миляуша',
  surname: 'Мубаракшина',
  patronymicName: 'Магсумовна',
  taxNumber: '164303829123',
  tel: '79518988142',
  img: '/images/teachers/milya.webp',
  facts: ['Опыт работы в международной команде 2+ года', 'TOEFL на 100 баллов (уровень английского С1+)', 'Хронически изучаю языки, говорю на 4х, понимаю 8', 'Готова поддержать разговор на любую тему in English: обсудим токсичность коллег, темы выгорания и трудоголии миллениалов, помогу разобраться с офисным сленгом.'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'Анна',
  surname: 'Султаншина',
  patronymicName: 'Ринатовна',
  taxNumber: '165056930262',
  tel: '79060587703',
  img: '/images/teachers/anna.webp',
  facts: ['Опыт работы со взрослыми 6 лет', 'Говорю на 5 языках: русский, английский, арабский, персидский и японский', 'Помогаю в составлении резюме и сопроводительного письма', 'Жила в Европе, общаясь только с носителями языка'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'Алика',
  surname: '',
  patronymicName: '',
  taxNumber: 'COMPANY',
  tel: 'COMPANY',
  img: '/images/teachers/alika.webp',
  facts: ['Опыт преподавания 7 лет', 'Училась в Новой Зеландии и Бельгии', 'Действующий синхронный переводчик', 'Преподавала в МГУ им. М.В. Ломоносова на кафедре теории и методологии перевода', 'Мои студенты успешно проходят международные собеседования в иностранные компании'],
  isVisibleOnPaymentPage: false
}, {
  id: uuid(),
  name: 'Валерия',
  surname: 'Елькина',
  patronymicName: 'Викторовна',
  taxNumber: '590618181449',
  tel: '79504747067',
  img: '/images/teachers/lera-2.webp',
  facts: ['Обучаю анлийскому более 9 лет', 'Подтвержденный Кембриджем диплом о уровне C2', 'Экспат с 2018 года', '3 года жила и преподавала английский в Китае', 'Регулярно посещаю книжный клуб на английском'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'Ирина',
  surname: 'Дробышевская',
  patronymicName: 'Олеговна',
  taxNumber: '281505616128',
  tel: '79957857300',
  img: '/images/teachers/irina.webp',
  facts: ['Говорю на 4 языках (русский, английский, китайский, грузинский)', 'Обучаю английскому более 7 лет', 'Уровень английского С2', 'Мастер спорта по плаванию и двукратная чемпионка мира по зимнему плаванию'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'Альбина',
  surname: 'Шарипова',
  patronymicName: 'Ринатовна',
  taxNumber: '164446675626',
  tel: '79172457987',
  img: '/images/teachers/albina.webp',
  facts: ['Преподаю более 6 лет', 'Училась в США', 'Жила и работала учителем в Китае', 'Работала менеджером T&D отдела в IT компании', 'Успешно готовлю к TOEFL'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'Данила',
  surname: 'Комаров',
  patronymicName: 'Алексеевич',
  taxNumber: '772460589600',
  tel: '79858098771',
  img: '/images/teachers/danila.webp',
  facts: ['Провел более 2500 индивидуальных и групповых занятий', 'Преподавал в Болгарии и Китае', 'Поднимаю уровень с A2 до B2 за 8-9 месяцев', 'Даю уверенность в своих силах на собеседовании', 'Разговариваем >90% времени на уроке'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'Мария',
  surname: 'Анисимова',
  patronymicName: 'Александровна',
  taxNumber: '501009622435',
  tel: '375298986783',
  img: '/images/teachers/mariya-anisimova.webp',
  facts: ['16+ лет опыта преподавания английского', 'Работала на английском и французском в международных компаниях, поэтому знаю, какой английский нужен для работы', 'Обожаю английский для специальных целей', 'Получила степень магистра филологии'],
  isVisibleOnPaymentPage: true
}];